export default __webpack_public_path__ + "static/media/logo-dark.2f94fa87.svg";